/* eslint-disable @ngrx/on-function-explicit-return-type */
import { createReducer, on } from '@ngrx/store';
import { FeatureFlags } from '@ra-state';
import * as R from 'remeda';
import { deleteFeatureFlag, setFeatureFlags, updateFeatureFlag } from './feature-flags.actions';

export const featureFlagsInitialState: FeatureFlags = {};

export const featureFlagsReducer = createReducer(
  featureFlagsInitialState,
  on(setFeatureFlags, (state: FeatureFlags, { flags }) => {
    return { ...state, flags: flags };
  }),
  on(updateFeatureFlag, (state: FeatureFlags, { payload: harnessUpdate }) => {
    const flags = R.clone(state.flags);
    if (flags) {
      flags[harnessUpdate.flag] = harnessUpdate.value;
    }
    return { ...state, flags: flags };
  }),
  on(deleteFeatureFlag, (state: FeatureFlags, { payload: flag }) => {
    const flags = R.clone(state.flags);
    if (flags) {
      delete flags[flag];
    }
    return { ...state, flags: flags };
  }),
);
